import React from "react";
import { useUrlSearchParams } from "../../../commons/hooks/useUrlSearchParams.js";
import {
  OnboardingFlowStage,
  VALID_ONBOARDING_FLOW_STAGES,
} from "./OnboardingFlowModal.js";

export const ONBOARDING_FLOW_URL_SEARCH_PARAM = "ofs";

export function useOnboardingFlow() {
  const { urlSearchParams, setUrlSearchParams } = useUrlSearchParams();

  const onboardingFlowStageUrlSearchParam = urlSearchParams.get(
    ONBOARDING_FLOW_URL_SEARCH_PARAM
  );
  const onboardingFlowStage = isValidOnboardingFlowStage(
    onboardingFlowStageUrlSearchParam
  )
    ? onboardingFlowStageUrlSearchParam
    : null;

  const setOnboardingFlowStage = React.useCallback(
    (newStage: OnboardingFlowStage | null) => {
      if (newStage) {
        setUrlSearchParams({
          [ONBOARDING_FLOW_URL_SEARCH_PARAM]: newStage,
        });
      } else {
        setUrlSearchParams({}, [ONBOARDING_FLOW_URL_SEARCH_PARAM]);
      }
    },
    [setUrlSearchParams]
  );

  return {
    onboardingFlowStage,
    setOnboardingFlowStage,
  };
}

function isValidOnboardingFlowStage(
  value: string | null
): value is OnboardingFlowStage {
  return value !== null && VALID_ONBOARDING_FLOW_STAGES.includes(value as any);
}
